import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Box, Divider, Grid, IconButton, MenuItem, Tooltip, Typography } from "@mui/material";

/** COMPONENT */
import InputTextField from "../../component/input/inputTextField";
import InputDatePicker from "../../component/input/inputDatePicker";

/** API, UTIL */
import FilterSelect from "../../component/select/filterSelect";
import PrefixApi from "../../api/setting/prefix/prefix.api";

/** STYLE, CONSTANT */
import * as Style from "../stall/stall-agreement/stallAgreement.style";
import { background, imgs } from "../../constants/images";
import ProvincesApi from "../../api/setting/provinces/provinces.api";
import UserApi from "../../api/auth/users.api";
import { useDropzone } from "react-dropzone";
import { notiError, notiSuccess } from "../../component/notification/notifications";
import { getProfile, setProfile } from "../../utils/app.utils";
import ButtonCustom from "../../component/button/buttonCustom";
import { Col } from "react-bootstrap";
import AutocompleteSelect from "../../component/select/autoCompleteSelect";
import { decode } from 'js-base64';
import { colors } from "../../constants/colors";
import HelperText from "../../component/input/helperText";
import Loading from "../../component/loading/loading";
import LoginApi from "../../api/auth/auth.api";
import { encode } from 'js-base64';
import { swalActive, swalDelete, swalError, swalSuccess } from "../../component/notification/swal";
import TableRowCommon from "../../component/table/TableRowCommon";
import { dateToView } from "../../utils/date.utils";
import TableCustom from "../../component/table/tableCustom";
import CustomerAgentApi from "../../api/customer-agent/customer-agent.api";
import { routeName } from "../../routes/routers-name";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import PermMediaIcon from '@mui/icons-material/PermMedia';
import CustomerCorporationApi from "../../api/customer-corporation/customer-corporation.api";
import { getFileExtension } from "../../utils/fileTypeDownload";
import saveAs from "file-saver";


type errorMessage = {
  idCard: string;
  birthDay: string;
  taxId: string;
  provinceId: string;
  disTrictId: string;
  subDistrictId: string;
  houseNumber: string;
}
const initialErrorMessage: errorMessage = {
  idCard: ``,
  provinceId: ``,
  birthDay: ``,
  taxId: ``,
  disTrictId: ``,
  subDistrictId: ``,
  houseNumber: ``
}


export default function EditProfile() {
  const { t }: any = useTranslation();
  const profile: any = JSON.parse(getProfile() || '{}')
  const history = useHistory()

  const [errorMessage, setErrorMessage] = useState<errorMessage>(initialErrorMessage)
  const clearErrorMessage = () => setErrorMessage(initialErrorMessage);

  const [prefixData, setPrefixData] = useState<any[]>([]);
  const [prefix, setPrefix] = useState<string>("นาย");
  const [tab, setTab] = useState<any>(1)

  const [provinceData, getProvinceData] = useState<any[]>([]);
  const [districtsData, getDistrictsData] = useState<any[]>([]);
  const [subDistrictsData, getSubDistrictsData] = useState<any[]>([]);
  const [provinceId, setProvinceId] = useState<string>("");
  const [districtsId, setDistrictsId] = useState<string>("");
  const [subDistrictsId, setSubDistrictsId] = useState<number>(Number);
  const [firstname, setFirstname] = useState<string>("");
  const [lastname, setLastname] = useState<string>("");
  const [firstname_en, setFirstnameEn] = useState<string>("");
  const [lastname_en, setLastnameEn] = useState<string>("");
  const [idCard, setIdCard] = useState<string>("");
  const [birthDay, setBirthDay] = useState<string>("");
  const [mobilePhone, setMobilePhone] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [taxId, setTaxId] = useState<string>("");
  const [houseNumber, setHouseNumber] = useState<string>("");
  const [moo, setMoo] = useState<string>("");
  const [village, setVillage] = useState<string>("");
  const [soi, setSoi] = useState<string>("");
  const [road, setRoad] = useState<string>("");
  const [zipCode, setZipCode] = useState<string>("");
  const [file, setFile] = useState<any>('')
  const [type, setType] = useState<any>('')
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [limitPage, setLimitPage] = useState<number>(5);
  const [rowCount, setRowCount] = useState<number>();
  const [sortBy, setSortBy] = useState<string>("modifiedDate");
  const [sortType, setSortType] = useState<string>("ASC");
  const [search, setSearch] = useState<string>("");
  const getPrefixes = async () => {
    const condition: any = {
      page: 1,
      pageLimit: 5,
      status: "ACTIVE"
    };

    const res = await PrefixApi.findAll(condition);
    setPrefixData(res.data);
  };

  const getUserProfile = async () => {
    const condition: any = {
      id: JSON.parse(decode(profile))?.userId
    }
    await UserApi.getDetail(condition).then((res) => {
      if (res?.status === 200) {
        setFirstname(res?.data?.firstname)
        setFirstnameEn(res?.data?.firstname_en)
        setFile(res?.data?.pictureProfile)
        setLastnameEn(res?.data?.lastname_en)
        setLastname(res?.data?.lastname)
        setIdCard(res?.data?.idCard)
        setBirthDay(res?.data?.birthDay)
        setMobilePhone(res?.data?.mobilePhone)
        setEmail(res?.data?.email)
        setTaxId(res?.data?.taxId)
        setHouseNumber(res?.data?.houseNumber)
        setMoo(res?.data?.moo)
        setVillage(res?.data?.village)
        setSoi(res?.data?.soi)
        setRoad(res?.data?.road)
        setProvinceId(res?.data?.provinceId)
        setDistrictsId(res?.data?.districtId)
        setSubDistrictsId(res?.data?.subDistrictId)
        setZipCode(res?.data?.zipCode)
        setPrefix(res?.data?.prefixId)
        setFile(res?.data?.profile)
        setType(res?.data?.customer_type)
        // setForm(res?.data)
      }
    })
  }
  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      const fileName = file?.name.split(".");
      const detailImage = {
        fileId: null,
        base64: "",
        fileExtension: fileName[fileName?.length - 1],
        fileSize: file.size.toString(),
      };
      const reader: any = new FileReader();
      reader.addEventListener("load", () => {
        const base64 = reader.result.split(",");
        setFile(reader.result);
        detailImage.base64 =
          base64.length > 0 ? base64[base64?.length - 1] : reader?.result;
      });
      reader.readAsDataURL(file);

    },
    [file]
  );
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  useEffect(() => {
    if (JSON.parse(decode(profile))?.roleId === 4) {
      getUserProfile()
    }
  }, []);
  useEffect(() => {
    getPrefixes();
  }, []);

  const getProvince = async () => {
    await ProvincesApi.findAll()
      .then((res) => {
        if (res.status === 200) {
          getProvinceData(res.data);
        } else {
          getProvinceData([])
        }
      })
  }

  useEffect(() => {
    getProvince()
  }, [])
  const getDistricts = useCallback(async () => {
    const condition: any = {
      provinceId: Number(provinceId)
    };
    await ProvincesApi.districts(condition)
      .then((res) => {
        if (res.status === 200) {
          getDistrictsData(res.data);
        } else {
          getDistrictsData([])
        }
      })

  }, [provinceId]);

  const getSubDistricts = useCallback(async () => {
    const condition: any = {
      districtId: Number(districtsId)
    };

    await ProvincesApi.subDistricts(condition)
      .then((res) => {
        if (res.status === 200) {
          getSubDistrictsData(res.data);
        } else {
          getSubDistrictsData([])
        }
      })
  }, [districtsId]);

  useEffect(() => {
    getDistricts();
  }, [provinceId]);

  useEffect(() => {
    getSubDistricts();
  }, [districtsId]);


  const validation = (): boolean => {
    let validationChecked: boolean = false;
    if (!idCard.split("-").join("").replaceAll("_", "")) {
      setErrorMessage((prev) => ({ ...prev, idCard: 'ระบุเลขบัตรประจำตัวประชาชน' }));
      return validationChecked = true;
    } else if (idCard.split("-").join("").replaceAll("_", "").length !== 13) {
      setErrorMessage((prev) => ({ ...prev, idCard: 'เลขบัตรประจำตัวประชาชนต้องมี 13 หลัก' }));
      return validationChecked = true;
    } else if (!birthDay) {
      setErrorMessage((prev) => ({ ...prev, birthDay: 'ระบุวัน/เดือน/ปีเกิด' }))
      return validationChecked = true;
    } else if (taxId && taxId.split("-").join("").replaceAll("_", "").length !== 13 && taxId.split("-").join("").replaceAll("_", "").length !== 0) {
      setErrorMessage((prev) => ({ ...prev, taxId: 'ระบุเลขภาษีให้ครบ 13 หลัก' }))
      return validationChecked = true;
    } else if (!houseNumber) {
      setErrorMessage((prev) => ({ ...prev, houseNumber: 'ระบุที่อยู่' }))
      return validationChecked = true;
    } else if (!provinceId) {
      setErrorMessage((prev) => ({ ...prev, provinceId: 'ระบุจังหวัด' }))
      return validationChecked = true;
    } else if (!districtsId) {
      setErrorMessage((prev) => ({ ...prev, disTrictId: 'ระบุอำเภอ' }))
      return validationChecked = true;
    } else if (!subDistrictsId) {
      setErrorMessage((prev) => ({ ...prev, subDistrictId: 'ระบุตำบล' }))
      return validationChecked = true;
    }
    return validationChecked
  }

  const onSubmit = async () => {

    const validate: boolean = validation();
    if (validate) {
      return;
    } else {
      const condition: any = {
        prefixId: Number(prefix),
        firstname: firstname,
        lastname: lastname,
        firstname_en: firstname_en,
        lastname_en: lastname_en,
        idCard: idCard?.split("-").join(""),
        birthDay: birthDay,
        mobilePhone: mobilePhone ? mobilePhone?.split("-").join("") : "",
        email: email,
        taxId: taxId ? taxId.includes('_____') ? null : taxId?.split("-").join("") : "",
        houseNumber: houseNumber,
        moo: moo,
        village: village,
        soi: soi,
        road: road,
        provinceId: provinceId,
        districtId: districtsId,
        subDistrictId: subDistrictsId,
        zipCode: zipCode,
        status: "ACTIVE",
        // profile: file
      }
      console.log(condition);
      setIsLoading(true)
      await UserApi.update(condition, JSON.parse(decode(profile))?.userId)
        .then(async (res) => {
          if (res.status < 300) {
            await LoginApi.profile()
              .then((res: any) => {
                if (res.status === 200) {
                  setProfile(encode(JSON.stringify(res.data)))
                  setIsLoading(false)
                  notiSuccess(t('อัพเดตข้อมูล สำเร็จ'), 'go', '/')
                } else {
                  setIsLoading(false)
                  notiError(t("อัพเดตข้อมูล ไม่สำเร็จ"), 'reload');
                }
              })
              .catch(error => {
                setIsLoading(false)
                swalError(error.response.data.error_description || 'อัพเดตข้อมูล ไม่สำเร็จ');

              })
          }

        })
        .catch((error) => {
          setIsLoading(false)
          swalError(error.response.data.error_description || 'อัพเดตข้อมูล ไม่สำเร็จ');
        })
    }
  }
  const loadData = useCallback(async () => {
    let condition: any = {
      sortBy: "createDate",
      sortType: "DESC",
      customerId: JSON.parse(decode(profile))?.customerId
      // branchId:branchId
    };
    if (page) condition = { ...condition, page: page };
    if (limitPage) condition = { ...condition, limit: limitPage };
    if (search) condition = { ...condition, keyword: search };

    const res = await CustomerAgentApi.list(condition);

    if (res.data.status < 300) {
      // console.log(res.data.data);
      setRowCount(res?.data.data?.meta?.itemsPerPage);
      setData(res?.data.data?.items);
    } else {
      setRowCount(0);
      setData([]);
    }
  }, [page, limitPage, search]);

  useEffect(() => {
    loadData()
  }, [loadData])

  const handlePageChange = (newPage: number) => setPage(newPage);
  const handlePageLimitChange = (newPageLimit: number) => setLimitPage(newPageLimit);

  const onRequestSort = (sortBy: string, sortType: string) => {
    setSortType(sortType);
    setSortBy(sortBy);
  };

  const deleteAgent = async (id: any) => {

    const res = await CustomerAgentApi.delete(id);
    if (res.data.status < 300) {
      swalSuccess('ลบเรียบร้อย', undefined, undefined, () => {
        loadData()
      })
    }
  };
  const headCells = [
    { id: "no", disablePadding: false, label: "ลำดับ", align: "center", },
    {
      id: "date",
      disablePadding: false,
      label: 'ชื่อ-นามสกุล',
      align: "left",
    },
    {
      id: "title",
      disablePadding: false,
      label: "เบอร์โทรศัพท์",
      align: "left",
    },

    {
      id: "action",
      disablePadding: false,
      align: "center",
      label: '',
    },
  ];
  const renderData = (objData: any, no: any) => {
    // no = page * pageLimit - pageLimit + no + 1
    no = page * limitPage - limitPage + no + 1;
    const {
      customer_fullname,
      customer_agent_mobilePhone,
      id_customer_agent
    } = objData;

    const objRenderData = {
      key: id_customer_agent,
      id: id_customer_agent,
      obj: objData,

      columns: [
        {
          option: "TEXT",
          align: "center",
          label: no,
        },
        {
          option: "TEXT",
          align: "left",
          label: customer_fullname,
        },
        {
          option: "TEXT",
          align: "left",
          label: customer_agent_mobilePhone || "-",
        },

        {
          option: "COMPONENT",
          align: "center",
          component: (
            <div className="d-flex align-items-center justify-content-center mx-auto w-100">
              <Tooltip title="ดู">
                <IconButton onClick={() => {
                  history.push(`${routeName.agentProfile}/${id_customer_agent}`)
                }}>
                  <FontAwesomeIcon
                    icon={faEye}
                    style={{
                      fontSize: "20px",
                      width: "22px",
                      color: colors.themeMainColor
                    }}
                  />
                </IconButton>
              </Tooltip>

              <Tooltip title="ลบ">
                <IconButton onClick={() => {
                  // history.push(`${routeName.detailinfo}/${announceId}`)
                  // swalDelete('ต้องการจะลบหรือไม่', undefined, () => deleteAgent(id_customer_agent))
                  swalActive(
                    'ต้องการจะลบหรือไม่ ?', '',
                    (status: any) => {
                      if (status) {
                        deleteAgent(id_customer_agent)
                      } else {
                        return;
                      }
                    },
                    'info',
                    'ลบ')
                }}>
                  <FontAwesomeIcon
                    icon={faTrash}
                    style={{
                      fontSize: "20px",
                      width: "22px",
                      color: colors.themeMainColor
                    }}
                  />
                </IconButton>
              </Tooltip>

            </div>
          ),
        },
      ],
    };
    return (
      <TableRowCommon {...objRenderData} />
    );
  };


  return (
    <div className="w-100 position-relative">
      {isLoading && <Loading show />}
      <Style.MainContainer>
        <Style.Topic>{t("ADMIN.PROFILE")}</Style.Topic>
        <Divider className="mx-0" />
        <div style={{ display: 'flex', gap: '5px', margin: '10px 0px' }}>
          <ButtonCustom
            textButton={'ข้อมูลส่วนบุคคล'}
            style={{ margin: '0px' }}
            onClick={() => setTab(1)}
            variant={tab === 1 ? 'contained' : 'outlined'}
          // btnStyle={{
          //   background: tab === 1 ? colors.themeMainColor : colors.gray
          // }}
          />
          <ButtonCustom
            textButton={'ผู้ทำการแทน'}
            style={{ margin: '0px' }}
            onClick={() => setTab(2)}
            // btnStyle={{
            //   background: tab === 2 ? colors.themeMainColor : colors.gray
            // }}
            variant={tab === 2 ? 'contained' : 'outlined'}
          />

        </div>
        {tab === 1 && <>

          {type === 'CORPORATION' ? <>
            <ProfileCorp id={JSON.parse(decode(profile))?.customerId} />
          </> : <>
            <Style.InformationRenter>
              <Style.BgInformation>
                <Grid container spacing={2}>
                  {/* <Grid
                item
                lg={3}
                sm={12}
                xs={12}
                className="w-100 d-flex justify-content-center"
              >
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  {file ? <Style.PicRenter src={file} alt="" /> : <Style.PicRenter src={imgs.defaultAvatar} alt="" />}

                </div>
              </Grid> */}
                  <Style.GridInput item lg={4} sm={4} xs={4}>
                    <div className="">
                      <FilterSelect
                        onchange={(e: any) => {
                          setPrefix(e.target.value)
                        }}
                        options={prefixData && prefixData.map((e: any) => {
                          return <MenuItem value={e.prefixId} >{e.prefixNameTh || e.prefixNameEn}</MenuItem>;
                        })}
                        selectId="select-prefix"
                        value={prefix}
                        labelId="label-prefixId"
                        required

                        heading={t("AGREEMENT.INPUT.PREFIX")}
                      />
                    </div>
                  </Style.GridInput>
                  <Style.GridInput item lg={4} sm={4} xs={8}>
                    <div>
                      <InputTextField

                        value={firstname}
                        onchange={(e: any) => setFirstname(e.target.value)}
                        size="medium"
                        heading={t("AGREEMENT.INPUT.FIRST_NAME")}
                      />
                    </div>
                  </Style.GridInput>
                  <Style.GridInput item lg={4} md={4} sm={4} xs={12}>
                    <div>
                      <InputTextField

                        value={lastname}
                        onchange={(e: any) => setLastname(e.target.value)}
                        size="medium"
                        heading={t("AGREEMENT.INPUT.LAST_NAME")}
                      />
                    </div>
                  </Style.GridInput>
                  <Grid item lg={4} sm={4} xs={8}>
                    <div>
                      <InputTextField

                        value={firstname_en}
                        onchange={(e: any) => setFirstnameEn(e.target.value)}
                        size="medium"
                        heading={t("AGREEMENT.INPUT.FIRST_NAME") + ` (ภาษาอังกฤษ)`}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <div>
                      <InputTextField

                        value={lastname_en}
                        onchange={(e: any) => setLastnameEn(e.target.value)}
                        size="medium"
                        heading={t("AGREEMENT.INPUT.LAST_NAME") + ` (ภาษาอังกฤษ)`}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={5} xs={12}>
                    <div className="mt-2">
                      <Style.FlexRow>
                        <Style.Detail>{t("AGREEMENT.INPUT.ID_CARD")} </Style.Detail>
                        <Style.RequestDetail>*</Style.RequestDetail>
                      </Style.FlexRow>
                      <Style.CustomPatternFormat
                        format={"#-####-#####-#-##"}
                        mask={"_"}
                        allowEmptyFormatting={true}
                        value={idCard}
                        onChange={(e: any) => {
                          setIdCard(e.target.value)
                          clearErrorMessage()
                        }}
                        required
                      />
                      {errorMessage.idCard && <HelperText label={errorMessage.idCard} />}
                    </div>
                  </Grid>
                  <Grid item lg={4} md={6} sm={5} sx={{ display: 'flex', gap: 2, justifyContent: 'flex-start', alignItems: 'center' }}>
                    <div className="mt-2 w-100">
                      <InputDatePicker
                        required
                        disableFuture
                        value={birthDay}
                        allowClear
                        onClear={() => setBirthDay("")}
                        key={"date"}
                        onChange={(e: any) => {
                          setBirthDay(moment(e).format("YYYY-MM-DD"))
                          clearErrorMessage()
                        }}
                        helperText={errorMessage.birthDay}
                        heading={t("AGREEMENT.INPUT.BIRTH_DAY")}
                      />
                    </div>
                    <div className="d-flex flex-column mt-2">
                      <Style.FlexRow>
                        <Style.Detail>{t("AGREEMENT.INPUT.AGE")} </Style.Detail>
                        {/* <Style.RequestDetail>*</Style.RequestDetail> */}
                      </Style.FlexRow>
                      <Style.BoxInputAge>
                        <InputTextField
                          disabled
                          value={birthDay && moment().diff(birthDay, "years")}
                          inputTextAlign="center"
                          size="medium"
                        />
                        <Typography className="ml-2">
                          {t("AGREEMENT.INPUT.YEAR")}
                        </Typography>
                      </Style.BoxInputAge>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <div className="mt-2">
                      <Style.Heading>{t("AGREEMENT.INPUT.TEL")}</Style.Heading>
                      <Style.CustomPatternFormat
                        format={"###-###-####"}
                        mask={"_"}
                        allowEmptyFormatting={true}
                        value={mobilePhone}
                        onChange={(e: any) => setMobilePhone(e.target.value)}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <div className="mt-2">
                      <InputTextField
                        disabled
                        value={email}
                        onchange={(e: any) => setEmail(e.target.value)}
                        size="medium"
                        required
                        heading={t("AGREEMENT.INPUT.EMAIL")}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <div className="mt-2">
                      <Col>
                        <Style.Heading sx={{ display: "flex", gap: 1 }}>{t("AGREEMENT.INPUT.TAX_ID")} <div className="text-danger">{"(ถ้ามี)"}</div></Style.Heading>
                        <Style.CustomPatternFormat
                          format={"#-####-#####-#-##"}
                          mask={"_"}
                          allowEmptyFormatting={true}
                          value={taxId}
                          onChange={(e: any) => {
                            setTaxId(e.target.value)
                            clearErrorMessage()
                          }}
                        />
                      </Col>
                      {errorMessage.taxId && <HelperText label={errorMessage.taxId} />}
                    </div>
                  </Grid>
                  <Grid item lg={4} md={3} sm={6} xs={12}>
                    <div className="mt-2">
                      <InputTextField
                        helperText={errorMessage.houseNumber}
                        required
                        value={houseNumber}
                        onchange={(e: any) => {
                          setHouseNumber(e.target.value)
                          clearErrorMessage()
                        }}
                        size="medium"
                        heading={t("AGREEMENT.INPUT.ADRESS")}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <div className=" mt-2">
                      <InputTextField
                        value={moo}
                        onchange={(e: any) => setMoo(e.target.value)}
                        size="medium"
                        heading={t("AGREEMENT.INPUT.MOO")}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <div className=" mt-2">
                      <InputTextField
                        value={village}
                        onchange={(e: any) => setVillage(e.target.value)}
                        size="medium"
                        heading={t("AGREEMENT.INPUT.VILLAGE")}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={3} md={3} sm={4} xs={12}>
                    <div className=" mt-2">
                      <InputTextField
                        value={soi}
                        onchange={(e: any) => setSoi(e.target.value)}
                        size="medium"
                        heading={t("AGREEMENT.INPUT.SOI")}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={3} sm={4} xs={12}>
                    <div className=" mt-2">
                      <InputTextField
                        value={road}
                        onchange={(e: any) => setRoad(e.target.value)}
                        size="medium"
                        heading={t("AGREEMENT.INPUT.ROAD")}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={3} sm={4} xs={12}>
                    <div className=" mt-2">
                      <AutocompleteSelect
                        options={provinceData}
                        getOptionLabel={(option) => option.provinceNameTh || option.provinceNameEn || ""}
                        onChange={(event, value) => {
                          clearErrorMessage()
                          if (value) {
                            setProvinceId(value.provinceId)
                            setDistrictsId("");
                            setSubDistrictsId(0)
                            setZipCode("")
                          }
                        }}
                        helperText={errorMessage.provinceId}
                        value={provinceData.find((d) => d?.provinceId === provinceId) || provinceId || null}
                        labelId="label-provinceId"
                        required={true}
                        heading={t("STALL.DETAIL.CITY")}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={3} md={4} sm={4} xs={12}>
                    <div className=" mt-2">
                      <AutocompleteSelect
                        options={districtsData}
                        getOptionLabel={(option) => option.districtNameTh || option.districtNameEn || ""}
                        onChange={(event, value) => {
                          clearErrorMessage()
                          if (value) {
                            setDistrictsId(value.districtId);
                            setSubDistrictsId(0)
                          }
                        }}
                        helperText={errorMessage.disTrictId}
                        value={districtsData && districtsData.find((d) => d?.districtId === districtsId) || districtsId || null}
                        labelId="label-districts"
                        required={true}
                        heading={t("STALL.DETAIL.DISTRICT")}
                      />

                    </div>
                  </Grid>
                  <Grid item lg={3} md={4} sm={4} xs={12}>
                    <div className=" mt-2">
                      <AutocompleteSelect
                        options={subDistrictsData}
                        getOptionLabel={(option) => option.subDistrictNameTh || option.subDistrictNameEn || ""}

                        onChange={(event, value) => {
                          clearErrorMessage()
                          if (value !== null) {
                            setSubDistrictsId(value.subDistrictId);
                            const selectedSubDistrict = subDistrictsData.find((d) => d.subDistrictId === value?.subDistrictId || null);
                            const { postcode } = selectedSubDistrict || {};
                            setZipCode(postcode || "");

                          } else {
                            setZipCode('');
                          }
                        }}
                        helperText={errorMessage.subDistrictId}
                        value={subDistrictsData && subDistrictsData.find((d) => d.subDistrictId === subDistrictsId) || subDistrictsId}
                        labelId="label-subDistricts"
                        required={true}
                        heading={t("STALL.DETAIL.SUB_DISTRICT")}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={3} md={4} sm={4} xs={12}>
                    <div className=" mt-2">
                      <InputTextField
                        required
                        disabled
                        value={zipCode}
                        onchange={(e: any) => setZipCode(e.target.value)}
                        size="medium"
                        heading={t("AGREEMENT.INPUT.ZIPCODE")}
                      />
                    </div>
                  </Grid>
                </Grid>
              </Style.BgInformation>
            </Style.InformationRenter>


            <ButtonCustom
              textButton={t("AGREEMENT.BUTTON.SAVE")}
              style={{ width: "100%" }}
              onClick={() => onSubmit()}
            />
          </>}
        </>}
        {tab === 2 && <>
          <div style={{ display: 'flex', justifyContent: "space-between", gap: '5px', margin: '10px 0px' }}>

            <InputTextField
              placeholder={'ค้นหา'}
              label={'ค้นหา'}
              value={search}
              onchange={(event) => {
                setSearch(event.target.value)
                setPage(1)
              }}
              style={{ width: '450px' }}
            />

            <ButtonCustom
              textButton={'เพิ่ม'}
              style={{ margin: '0px' }}
              onClick={() => history.push(routeName.agentProfile + '-add')}
            />

          </div>
          <TableCustom
            headCells={headCells}
            customScroll
            page={page}
            pageLimit={limitPage}
            sortType={sortType}
            sortBy={sortBy}
            rowCount={rowCount}
            rowsData={data.map((d: any, index: any) => {
              return renderData(d, index);
            })}
            onSort={onRequestSort}
            setPageLimit={handlePageLimitChange}
            setPage={handlePageChange}
            tableMinWidth={1400}
          />
        </>
        }


      </Style.MainContainer>
    </div>
  );
}


const ProfileCorp = (props: any) => {
  const { id } = props
  const profile: any = JSON.parse(getProfile() || '{}')
  const [files, setFiles] = useState<any[]>([]);
  const [filesDelete, setFilesDelete] = useState<any[]>([]);
  const uploadRefs = useRef<HTMLInputElement[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [houseNumber, setHouseNumber] = useState<string>("");
  const [moo, setMoo] = useState<string>("");
  const [village, setVillage] = useState<string>("");
  const [soi, setSoi] = useState<string>("");
  const [road, setRoad] = useState<string>("");
  const [zipCode, setZipCode] = useState<string>("");
  const { t }: any = useTranslation();
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [form, setForm] = useState<any>({});
  const [prefixOption, setPrefixOption] = useState<any[]>([]);
  const [provinceData, getProvinceData] = useState<any[]>([]);
  const [districtsData, getDistrictsData] = useState<any[]>([]);
  const [subDistrictsData, getSubDistrictsData] = useState<any[]>([]);
  const [provinceId, setProvinceId] = useState<string>("");
  const [districtsId, setDistrictsId] = useState<string>("");
  const [subDistrictsId, setSubDistrictsId] = useState<number>(Number);
  const clearErrorMessage = () => setErrorMessage({});

  const getUserProfile = async () => {
    const condition: any = {
      id: JSON.parse(decode(profile))?.userId
    }
    await UserApi.getDetail(condition).then((res) => {
      if (res?.status === 200) {

        setHouseNumber(res?.data?.houseNumber)
        setMoo(res?.data?.moo)
        setVillage(res?.data?.village)
        setSoi(res?.data?.soi)
        setRoad(res?.data?.road)
        setProvinceId(res?.data?.provinceId)
        setDistrictsId(res?.data?.districtId)
        setSubDistrictsId(res?.data?.subDistrictId)
        setZipCode(res?.data?.zipCode)

        // setForm(res?.data)
      }
    })
  }
  const getProfileDetail = async () => {
    setLoading(true)

    const res = await LoginApi.profile();
    // const condition: any = {
    //   id: JSON.parse(decode(profile))?.userId
    // }
    // await UserApi.getDetail(condition).then((res) => {
    //   if (res?.status === 200) {
    setForm(res.data);
    setFiles(res.data?.customer_files)

    setLoading(false)
    //   }
    // })

  };
  const getPrefixes = async () => {
    const condition: any = {
      page: 1,
      pageLimit: 10,
      status: "ACTIVE"
    };
    const res = await PrefixApi.findAll(condition);
    setPrefixOption(res.data);
  };




  const getProvince = async () => {
    await ProvincesApi.findAll()
      .then((res) => {
        if (res.status === 200) {
          getProvinceData(res.data);
        } else {
          getProvinceData([])
        }
      })
  }
  useEffect(() => {
    getPrefixes();
    getProfileDetail()
    getUserProfile()
    getProvince()
  }, []);
  const getDistricts = useCallback(async () => {
    const condition: any = {
      provinceId: Number(provinceId)
    };
    await ProvincesApi.districts(condition)
      .then((res) => {
        if (res.status === 200) {
          getDistrictsData(res.data);
        } else {
          getDistrictsData([])
        }
      })

  }, [provinceId]);

  const getSubDistricts = useCallback(async () => {
    const condition: any = {
      districtId: Number(districtsId)
    };

    await ProvincesApi.subDistricts(condition)
      .then((res) => {
        if (res.status === 200) {
          getSubDistrictsData(res.data);
        } else {
          getSubDistrictsData([])
        }
      })
  }, [districtsId]);

  useEffect(() => {
    getDistricts();
  }, [provinceId]);

  useEffect(() => {
    getSubDistricts();
  }, [districtsId]);

  const handleImportFileItem = async (id: any, obj: any, index: number) => {
    const file = obj

    const formData: FormData = new FormData();
    formData.append('file', file)
    formData.append('document_type', 'หนังสือรับรองนิติบุคคล')

    if (file) {
      await CustomerCorporationApi.register_file(id, formData).then((res) => {
        if (res.status < 300) {

          // alertSuccess("นำเข้าไฟล์", "นำเข้าไฟล์ เรียบร้อย", undefined, () => {
          //     window.location.reload()
          // })
        } else {
          // alertError("นำเข้าไฟล์", "นำเข้าไฟล์ ไม่สำเร็จ")
        }
        if (uploadRefs.current[index]) {
          uploadRefs.current[index].value = "";
        }
      }).catch((err) => {
        console.log(err);
        // alertError(err?.response?.data?.message || "นำเข้าไฟล์ ไม่สำเร็จ");
        if (uploadRefs.current[index]) {
          uploadRefs.current[index].value = "";
        }
      }).finally(() => {
      })
    } else {
      return false;
    }
  }
  const handleSubmit = async () => {

    const body = {
      ...form,
      prefixId: form?.customer_hier?.prefixId,
      taxId: form?.customer_hier?.taxId,
      corporat_type: form?.corporat_type,
      hier_firstname: form?.customer_hier?.firstname,
      hier_lastname: form?.customer_hier?.lastname,
      position_name: form?.customer_hier?.position_name,
      idCard: form?.customer_hier?.idCard,
      birthDay: form?.customer_hier?.birthDay,
      hier_mobile: form?.customer_hier?.mobilePhone,
      hier_email: form?.customer_hier?.email,
      houseNumber: houseNumber,
      moo: moo,
      village: village,
      soi: soi,
      road: road,
      provinceId: provinceId,
      districtId: districtsId,
      subDistrictId: subDistrictsId,
      zipCode: zipCode,
    }
    if (!body?.taxId)
      return setErrorMessage({
        ...errorMessage,
        ...{ taxId: 'ระบุเลขประจำตัวผู้เสียภาษี' },
      });

    if (!body?.corporat_type)
      return setErrorMessage({
        ...errorMessage,
        ...{ corporat_type: 'ระบุสถานะนิติบุคคล' },
      });
    if (!body?.firstname)
      return setErrorMessage({
        ...errorMessage,
        ...{ firstname: 'ระบุชื่อนิติบุคคล' },
      });
    if (!body?.prefixId)
      return setErrorMessage({
        ...errorMessage,
        ...{ prefixId: 'ระบุคำนำหน้า' },
      });
    if (!body?.hier_firstname)
      return setErrorMessage({
        ...errorMessage,
        ...{ hier_firstname: 'ระบุชื่อ' },
      });
    if (!body?.hier_lastname)
      return setErrorMessage({
        ...errorMessage,
        ...{ hier_lastname: 'ระบุนามสกุล' },
      });
    if (!body?.position_name)
      return setErrorMessage({
        ...errorMessage,
        ...{ position_name: 'ระบุตำแหน่ง' },
      });
    if (!body?.idCard)
      return setErrorMessage({
        ...errorMessage,
        ...{ idCard: 'ระบุเลขบัตรประชาชน' },
      });
    if (!body?.birthDay)
      return setErrorMessage({
        ...errorMessage,
        ...{ birthDay: 'ระบุวัน /เดือน /ปีเกิด' },
      });
    if (!body?.hier_mobile)
      return setErrorMessage({
        ...errorMessage,
        ...{ hier_mobile: 'ระบุเบอร์โทรศัพท์มือถือ' },
      });
    if (!body?.hier_email)
      return setErrorMessage({
        ...errorMessage,
        ...{ hier_email: 'ระบุอีเมล' },
      });
    if (!body?.email)
      return setErrorMessage({
        ...errorMessage,
        ...{ email: 'ระบุอีเมล' },
      });
    // if (!form?.password)
    //   return setErrorMessage({
    //     ...errorMessage,
    //     ...{ password: 'ระบุรหัสผ่าน' },
    //   });
    // if (!c_pass)
    //   return setErrorMessage({
    //     ...errorMessage,
    //     ...{ c_pass: 'ระบุรหัสผ่าน' },
    //   });
    // if (form?.password !== c_pass)
    //   return setErrorMessage({
    //     ...errorMessage,
    //     ...{ password: 'รหัสผ่านไม่ตรงกะน' },
    //   });
    if (files?.length === 0)
      return swalError('กรุณาเพิ่มหนังสือรับรองนิติบุคคล')
    setLoading(true)

    await CustomerCorporationApi.update(body, id).then(async (res: any) => {
      if (res.data) {
        const x = files?.filter((item: any) => !item?.id_customer_file)?.filter((item: any) => item?.name)
        if (x?.length > 0) {
          for (let index = 0; index < x.length; index++) {
            handleImportFileItem(id, x[index], index)
          }
        }
        if (filesDelete?.length > 0) {
          for (let index = 0; index < filesDelete.length; index++) {
            deleteFile(filesDelete[index]?.id_customer_file)
          }
        }
        setFilesDelete([])

        setLoading(false)

        swalSuccess('บันทึกเรียบร้อยแล้ว', undefined, undefined, () => getProfileDetail())

      }

    })
      .catch((error) => {
        console.log(error);
        swalError(error?.response?.data?.errorDescription);
        setLoading(false)


      });
  }
  const deleteFile = async (id: any) => {

    const res = await CustomerCorporationApi.delete(id);
    if (res.data.status < 300) {

    }
  };
  const downloadFile = async (id: number) => {
    try {
      const res = await CustomerCorporationApi.file(id);

      if (res.status < 300) {
        const response = res.data;

        // Get the content type from the server's response headers
        const contentType = res.headers["content-type"];

        // Create a Blob with the content type from the response
        const blob = new Blob([response], { type: contentType });

        // Extract file extension based on content type
        const fileExtension = getFileExtension(contentType || "");

        // Generate a filename with the correct extension (you can also modify this to use a custom name)
        const name_file = `${new Date().getTime()}`;
        const fileName = `${name_file}.${fileExtension}`;

        // Save the file
        saveAs(blob, fileName);
        // setLoading(false);
      }
    } catch (error) {
      notiError("ไม่สามารถดึงข้อมูลไฟล์ได้", "", null, null);
    }
  };
  return (
    <>


      <Grid spacing={2} container>
        <Grid item xs={12} md={3}>
          <Box
            className="w-100 d-flex justify-content-center mt-2"
          >
            {/* <div {...getRootProps()}>
                <input {...getInputProps()} />
                {file ? <Style.PicRenter src={file} alt="" /> : <Style.PicRenter src={imgs.defaultAvatar} alt="" />}

              </div> */}
            <Style.PicRenter src={imgs.defaultAvatar} alt="" />

          </Box>
          <div style={{ display: 'flex', flexDirection: "column", alignItems: "center", gap: '10px', marginTop: "20px" }}>
            <Typography sx={{ fontSize: "24px", fontWeight: "600" }}>{form?.customer_hier?.firstname} {form?.customer_hier?.lastname}</Typography>
            <Typography sx={{ color: '#A7A7A7' }}>{form?.customer_hier?.position_name}</Typography>
            <Typography sx={{ marginTop: "10px" }}>อีเมล : {form?.customer_hier?.email || '-'}</Typography>
            <Typography >เบอร์โทร : {form?.customer_hier?.mobilePhone || '-'}</Typography>

          </div>
        </Grid>
        <Grid item xs={12} md={9} sx={{ display: 'flex', flexDirection: "column", gap: '30px' }}>
          <Style.BgInformation>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography sx={{ fontSize: "18px", fontWeight: '600' }}>
                  ข้อมูลผู้ประกอบการค้า
                </Typography>
              </Grid>
              <Grid item lg={6} xs={12} className="w-100">
                <InputTextField

                  value={form?.customer_hier?.taxId}
                  onchange={(e) => {
                    setForm({ ...form, customer_hier: { ...form?.customer_hier, taxId: e.target.value } })

                    clearErrorMessage()
                  }}
                  required={true}
                  helperText={errorMessage.taxId}
                  inputProps={{
                    maxLength: 13,
                  }}
                  heading={t("เลขประจำตัวผู้เสียภาษี")}
                />
              </Grid>
              <Grid item lg={6} xs={12} className="w-100">
                <AutocompleteSelect
                  options={['บริษัทจำกัด', 'บริษัทจำกัด(มหาชน)', 'ห้างหุ้นส่วนจำกัด', 'ห้างหุ้นส่วนสามัญ(จดทะเบียน)', 'กลุ่มเกษตรกร', 'สหกรณ์']}
                  getOptionLabel={(option: any) => option}
                  onChange={(e, val) => {
                    setForm({ ...form, corporat_type: val })

                    clearErrorMessage()
                  }}
                  value={['บริษัทจำกัด', 'บริษัทจำกัด(มหาชน)', 'ห้างหุ้นส่วนจำกัด', 'ห้างหุ้นส่วนสามัญ(จดทะเบียน)', 'กลุ่มเกษตรกร', 'สหกรณ์']?.find((item) => item === form?.corporat_type) || null}
                  labelId="prefix-name"
                  heading={t("สถานะนิติบุคคล")}
                  required
                  helperText={errorMessage.corporat_type}
                />
              </Grid>
              <Grid item lg={6} xs={12} className="w-100">
                <InputTextField
                  value={form?.firstname}
                  onchange={(e) => {
                    setForm({ ...form, firstname: e.target.value })
                    clearErrorMessage()
                  }}
                  helperText={errorMessage.firstname}
                  required={true}
                  heading={t("ชื่อนิติบุคคล")}
                />
              </Grid>
              <Grid item lg={6} xs={12} className="w-100">
                <InputTextField
                  value={form?.firstname_en}
                  onchange={(e) => {
                    setForm({ ...form, firstname_en: e.target.value })
                    clearErrorMessage()
                  }}
                  helperText={errorMessage.firstname_en}
                  // required={true}
                  heading={t("ชื่อนิติบุคคล (ภาษาอังฤษ)")}
                />
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <div className="mt-2">
                  <InputTextField
                    helperText={errorMessage.houseNumber}
                    // required
                    value={houseNumber}
                    onchange={(e: any) => {
                      setHouseNumber(e.target.value)
                      clearErrorMessage()
                    }}
                    size="medium"
                    heading={t("AGREEMENT.INPUT.ADRESS")}
                  />
                </div>
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <div className=" mt-2">
                  <InputTextField
                    value={moo}
                    onchange={(e: any) => setMoo(e.target.value)}
                    size="medium"
                    heading={t("AGREEMENT.INPUT.MOO")}
                  />
                </div>
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <div className=" mt-2">
                  <InputTextField
                    value={village}
                    onchange={(e: any) => setVillage(e.target.value)}
                    size="medium"
                    heading={t("AGREEMENT.INPUT.VILLAGE")}
                  />
                </div>
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <div className=" mt-2">
                  <InputTextField
                    value={soi}
                    onchange={(e: any) => setSoi(e.target.value)}
                    size="medium"
                    heading={t("AGREEMENT.INPUT.SOI")}
                  />
                </div>
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <div className=" mt-2">
                  <InputTextField
                    value={road}
                    onchange={(e: any) => setRoad(e.target.value)}
                    size="medium"
                    heading={t("AGREEMENT.INPUT.ROAD")}
                  />
                </div>
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <div className=" mt-2">
                  <AutocompleteSelect
                    options={provinceData}
                    getOptionLabel={(option) => option.provinceNameTh || option.provinceNameEn || ""}
                    onChange={(event, value) => {
                      clearErrorMessage()
                      if (value) {
                        setProvinceId(value.provinceId)
                        setDistrictsId("");
                        setSubDistrictsId(0)
                        setZipCode("")
                      }
                    }}
                    helperText={errorMessage.provinceId}
                    value={provinceData.find((d) => d?.provinceId === provinceId) || provinceId || null}
                    labelId="label-provinceId"
                    required={true}
                    heading={t("STALL.DETAIL.CITY")}
                  />
                </div>
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <div className=" mt-2">
                  <AutocompleteSelect
                    options={districtsData}
                    getOptionLabel={(option) => option.districtNameTh || option.districtNameEn || ""}
                    onChange={(event, value) => {
                      clearErrorMessage()
                      if (value) {
                        setDistrictsId(value.districtId);
                        setSubDistrictsId(0)
                      }
                    }}
                    helperText={errorMessage.disTrictId}
                    value={districtsData && districtsData.find((d) => d?.districtId === districtsId) || districtsId || null}
                    labelId="label-districts"
                    required={true}
                    heading={t("STALL.DETAIL.DISTRICT")}
                  />

                </div>
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <div className=" mt-2">
                  <AutocompleteSelect
                    options={subDistrictsData}
                    getOptionLabel={(option) => option.subDistrictNameTh || option.subDistrictNameEn || ""}

                    onChange={(event, value) => {
                      clearErrorMessage()
                      if (value !== null) {
                        setSubDistrictsId(value.subDistrictId);
                        const selectedSubDistrict = subDistrictsData.find((d) => d.subDistrictId === value?.subDistrictId || null);
                        const { postcode } = selectedSubDistrict || {};
                        setZipCode(postcode || "");

                      } else {
                        setZipCode('');
                      }
                    }}
                    helperText={errorMessage.subDistrictId}
                    value={subDistrictsData && subDistrictsData.find((d) => d.subDistrictId === subDistrictsId) || subDistrictsId}
                    labelId="label-subDistricts"
                    required={true}
                    heading={t("STALL.DETAIL.SUB_DISTRICT")}
                  />
                </div>
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <div className=" mt-2">
                  <InputTextField
                    required
                    disabled
                    value={zipCode}
                    onchange={(e: any) => setZipCode(e.target.value)}
                    size="medium"
                    heading={t("AGREEMENT.INPUT.ZIPCODE")}
                  />
                </div>
              </Grid>

            </Grid>
          </Style.BgInformation>
          <Style.BgInformation>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography sx={{ fontSize: "18px", fontWeight: '600' }}>
                  ผู้ติดต่อ
                </Typography>
              </Grid>
              <Grid item lg={4} xs={12} className="w-100">
                <AutocompleteSelect
                  options={prefixOption}
                  getOptionLabel={(option: any) => option?.prefixNameTh}
                  onChange={(e, value) => {
                    setForm({ ...form, customer_hier: { ...form?.customer_hier, prefixId: value?.prefixId } })
                    clearErrorMessage()
                  }}
                  value={prefixOption?.find((item: any) => item?.prefixId === form?.customer_hier?.prefixId) || null}
                  labelId="prefix-name"
                  heading={t("REGISTER.INPUT.PREFIX")}
                  required
                  helperText={errorMessage.prefixId}
                />
              </Grid>
              <Grid item lg={4} xs={12} className="w-100">
                <InputTextField
                  key="name"
                  value={form?.customer_hier?.firstname}
                  onchange={(e) => {
                    setForm({ ...form, customer_hier: { ...form?.customer_hier, firstname: e.target.value } })
                    clearErrorMessage()
                  }}
                  required={true}
                  helperText={errorMessage.hier_firstname}
                  heading={t("REGISTER.INPUT.NAME")}
                />
              </Grid>
              <Grid item lg={4} xs={12} className="w-100">
                <InputTextField
                  key="lastName"
                  value={form?.customer_hier?.lastname}
                  onchange={(e) => {
                    setForm({ ...form, customer_hier: { ...form?.customer_hier, lastname: e.target.value } })
                    clearErrorMessage()
                  }}
                  helperText={errorMessage.hier_lastname}
                  required={true}
                  heading={t("REGISTER.INPUT.LAST_NAME")}
                />
              </Grid>
              <Grid item xs={12} className="w-100">
                <AutocompleteSelect
                  options={['กรรมการ/ผู้มีอำนาจ', 'พนักงาน/ตัวแทน']}
                  getOptionLabel={(option: any) => option}
                  value={['กรรมการ/ผู้มีอำนาจ', 'พนักงาน/ตัวแทน']?.find((item: any) => item === form?.customer_hier?.position_name) || null}
                  onChange={(e, value) => {
                    setForm({ ...form, customer_hier: { ...form?.customer_hier, position_name: value } })
                    clearErrorMessage()
                  }}
                  labelId="prefix-name"
                  heading={t("ตำแหน่ง")}
                  required
                  helperText={errorMessage.position_name}
                />
              </Grid>
              <Grid item lg={5} xs={12} className="w-100">
                <InputTextField

                  value={form?.customer_hier?.idCard}
                  onchange={(e) => {
                    setForm({ ...form, customer_hier: { ...form?.customer_hier, idCard: e.target.value } })
                    clearErrorMessage()
                  }}
                  required={true}
                  helperText={errorMessage.idCard}
                  inputProps={{
                    maxLength: 13,
                  }}
                  heading={t("เลขบัตรประชาชน")}
                />
              </Grid>
              <Grid item lg={5} xs={12} className="w-100">

                <InputDatePicker value={form?.customer_hier?.birthDay} onChange={function (val: any): void {
                  setForm({ ...form, customer_hier: { ...form?.customer_hier, birthDay: moment(val).format('YYYY-MM-DD') } })
                  clearErrorMessage()
                }} heading="วัน /เดือน /ปีเกิด" />
              </Grid>
              <Grid item lg={2} xs={12} className="w-100">
                <InputTextField

                  value={form?.customer_hier?.birthDay ? new Date().getFullYear() - new Date(form?.customer_hier?.birthDay).getFullYear() : ''}
                  disabled
                  required={true}
                  helperText={errorMessage.birthDay}

                  heading={t("อายุ")}
                />
              </Grid>
              <Grid item lg={6} xs={12} className="w-100">
                <InputTextField
                  value={form?.customer_hier?.mobilePhone}
                  onchange={(e) => {
                    setForm({ ...form, customer_hier: { ...form?.customer_hier, mobilePhone: e.target.value } })
                    clearErrorMessage()
                  }}
                  required={true}
                  helperText={errorMessage.hier_mobile}
                  inputProps={{
                    maxLength: 10,
                  }}
                  heading={t("REGISTER.INPUT.PHONE_NUMBER")}
                />
              </Grid>
              <Grid item lg={6} xs={12} className="w-100">
                <InputTextField
                  key="email"
                  required={true}
                  value={form?.customer_hier?.email}
                  onchange={(e) => {
                    setForm({ ...form, customer_hier: { ...form?.customer_hier, email: e.target.value } })
                    clearErrorMessage()
                  }}
                  helperText={errorMessage.hier_email}
                  heading={t("REGISTER.INPUT.EMAIL")}
                />
              </Grid>
            </Grid>
          </Style.BgInformation>
          <Style.BgInformation >
            <Grid container spacing={2}>
              <Grid item xs={12}>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end' }}>
                  <Typography sx={{ fontSize: "18px", fontWeight: '600' }}>
                    หนังสือรับรองนิติบุคคล <span style={{ fontSize: '14px', color: 'red' }}>(คัดรับรองไม่เกิน 6 เดือน) *</span>
                  </Typography>
                  <ButtonCustom
                    type="submit"
                    textButton={'เพิ่ม'}
                    onClick={() => {
                      setFiles([...files, {}])
                    }}
                    style={{ margin: '0px' }}
                    btnStyle={{
                      fontSize: "16px",
                      width: "100%",
                      padding: "0px",
                      margin: '0px'
                    }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} className="w-100">
                <div style={{ display: "flex", flexDirection: 'column', gap: '10px' }}>
                  {files?.map((item: any, index: number) => {
                    return (
                      <div key={index} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 20px', border: '1px solid #D9D9D9', borderRadius: '8px' }}>
                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                          <PermMediaIcon style={{ color: colors.themeMainColor, fontSize: "48px" }} />
                          {item?.name || item?.file_name || 'เลือกไฟล์'}
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>

                          {(item?.name || item?.file_name) ? <div style={{ display: 'flex', gap: "10px" }}><ButtonCustom textButton={'ดู'} onClick={() => {
                            if (item?.id_customer_file) {
                              downloadFile(item?.id_customer_file)
                            } else {
                              window.open(URL.createObjectURL(item), "_blank");
                            }
                          }} style={{ margin: '0px' }} /> <ButtonCustom mode={'del'} textButton={'ลบไฟล์'} onClick={() => {
                            if (item?.id_customer_file) {
                              // deleteFile(item?.id_customer_file)
                              // setFiles(files?.filter((item, i) => i !== index))
                              setFilesDelete([...filesDelete, item])
                              setFiles((pre) =>
                                pre.map((p, i) =>
                                  i === index ? {} : p
                                )
                              )
                            } else {
                              // setFiles(files?.filter((item, i) => i !== index))
                              setFiles((pre) =>
                                pre.map((p, i) =>
                                  i === index ? {} : p
                                )
                              )
                            }
                          }

                          } style={{ margin: '0px' }} /></div> : <ButtonCustom mode='add' textButton={'เลือก'} onClick={() => uploadRefs.current[index]?.click()} style={{ margin: '0px' }} />}
                          <ButtonCustom mode={'del'} textButton={'ลบ'} onClick={() => {
                            if (item?.id_customer_file) {
                              // deleteFile(item?.id_customer_file)
                              // setFiles(files?.filter((item, i) => i !== index))
                              setFilesDelete([...filesDelete, item])
                            }

                            setFiles(files?.filter((item, i) => i !== index))

                          }} style={{ margin: '0px' }} /></div>

                        <input type='file' ref={(el) => (uploadRefs.current[index] = el!)} onChange={(e: any) => setFiles((pre) =>
                          pre.map((p, i) =>
                            i === index ? e.target.files[0] : p
                          )
                        )} style={{ display: 'none' }} />
                      </div>
                    )
                  })}
                </div>
              </Grid>

            </Grid>
          </Style.BgInformation>
          <Style.BgInformation >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography sx={{ fontSize: "18px", fontWeight: '600' }}>
                  บัญชีผู้ใช้งาน
                </Typography>
              </Grid>
              <Grid item lg={4} xs={12} className="w-100">
                <InputTextField
                  key="name"
                  value={form?.email}
                  disabled
                  onchange={(e) => {
                    setForm({ ...form, email: e.target.value })
                    clearErrorMessage()
                  }}
                  required={true}
                  helperText={errorMessage.email || ''}
                  heading={t("อีเมล")}
                />
              </Grid>

              <Grid item lg={8} xs={12} className="w-100">
                <InputTextField
                  key="lastName"
                  value={form?.password}
                  onchange={(e) => {
                    setForm({ ...form, password: e.target.value })
                    clearErrorMessage()
                  }}
                  type="password"
                  helperText={errorMessage.password || ''}
                  required={true}
                  heading={t("รหัสผ่าน")}
                />
              </Grid>


            </Grid>
          </Style.BgInformation>
          <Grid spacing={2} container>

            <Grid item xs={12}>
              <ButtonCustom
                type="submit"
                textButton={t("REGISTER.BUTTON.SUMMIT")}
                onClick={() => {
                  handleSubmit()
                }}
                btnStyle={{
                  fontSize: "16px",
                  width: "100%",
                  padding: "0px",
                  marginTop: "32px",
                  marginBottom: "14px",
                }}
              />
            </Grid>


          </Grid>
        </Grid>

      </Grid >

      {loading && <Loading show={loading} type="fullLoading" />}

    </>
  )
}